export default "__VITE_ASSET__4efa9351__"